module.exports = __webpack_public_path__ + "img/user.f00b05b6.svg";